<template>
  <div>
    <div class="header flex-b-c">
      <div class="header-left">
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" active-text-color="#409EFF">
          <el-menu-item index="1">国内</el-menu-item>
          <el-menu-item index="2">国外</el-menu-item>
        </el-menu>
      </div>
      <div class="header-right">
        <el-button type="primary" size="mini" round @click="addTheme">新增主题</el-button>
      </div>
    </div>
    <div class="main-content">
      <Theme
        v-loading="themeListLoading"
        :themeList="themeList"
        :themeType="3"
        @editTheme="handleEditTheme"
        @openDelDialog="openDelDialog"
        @uploadSuccess="getThemeList"
      />
    </div>
    <theme-add 
      :themeDialog="themeDialogVisible"
      :type="3"
      :addEdit="themeAddEdit"
      :editData="themeEditData"
      @closeThemeDialog="closeThemeDialog"
    />
    <del-dialog :dialogVisible="DelDialogVisible" @closeDialog="delCloseDialog" :title="'删除主题'">
      <div class="dd-dialog">请问是否要永久删除该主题？</div>
    </del-dialog>
  </div>
</template>

<script>
import DelDialog from '@/components/basics/DelDialog'
import Theme from '../children/Theme'
import ThemeAdd from '../children/ThemeAdd'

export default {
  name: 'Font',
  data() {
    return {
      themeList: [],
      themeListLoading: false,
      themeAddEdit: "ADD",
      themeDialogVisible: false,
      themeEditData: {},
      themeDelId: 0,
      DelDialogVisible: false,
      activeIndex: '1',
    }
  },
  
  methods: {
    getThemeList(){
      this.themeListLoading = true;
      const foreign = +this.activeIndex;
      this.$http.post('/admin/template/getThemeList',{
        group_ids: this.$cookies.get('group_ids'),
        foreign,
        type: 3,
      },data => {
        this.themeList = data || [];
        this.themeListLoading = false;
      })
    },
    addTheme() {
      this.themeAddEdit = 'ADD';
      this.themeDialogVisible = true;
    },
    closeThemeDialog(isUpdate) {
      this.themeDialogVisible = false;
      isUpdate && this.getThemeList();
    },
    handleEditTheme(theme){
      this.themeAddEdit = 'EDIT';
      this.themeEditData = {
        id: theme.id,
        name: theme.name,
        description: theme.description,
      }
      this.themeDialogVisible = true;
    },
    openDelDialog(id) {
      this.DelDialogVisible = true;
      this.themeDelId = id
    },
    delCloseDialog(isConfirm) {
      if (isConfirm) {
        this.$http.post('/admin/template/deleteTheme',{
          ids: this.themeDelId,
        },() => {
          this.getThemeList();
        })
      }
      this.DelDialogVisible = false;
    },
    handleSelect(index) {
      this.activeIndex = index; 
      this.getThemeList();
    },
  },
  created() {
    this.getThemeList();
  },
  components: {
    Theme,
    ThemeAdd,
    DelDialog,
  }
}
</script>

<style lang="scss" scoped>
  .header {
    width: 100%;
    height: 60px;
      .header-left {
        margin-left: 20px;
        display: flex;
        justify-content: flex-start;
        .el-menu-demo {
          /deep/.el-menu-item{
            height: 48px;
            line-height: 48px;
          }  
         }
      }
      .header-right {
        margin-right: 20px;
      }
  }
  .main-content {
    height: calc(100% - 80px);
    padding: 0 20px;
    overflow: auto;
  }
</style>